import styled from 'styled-components'

export const Text = styled.div`
  font-size: ${(props) => props.size || `14px`};
  font-weight: ${(props) => props.weight || 400};
  color: ${(props) => props.color || 'var(--color-on-base-content-high)'};
  line-height: ${(props) => props.lineHeight || ''};
`

export const Text2 = styled.div`
  font-size: ${(props) => props.size || `12px`};
  font-weight: ${(props) => props.weight || 400};
  color: ${(props) => props.color || 'var(--color-on-base-content-low)'};
`
export const TextSub = styled.div`
  font-size: ${(props) => props.size || `12px`};
  font-weight: ${(props) => props.weight || 400};
  color: ${(props) => props.color || 'var(--color-on-base-content-subtle)'};
  line-height: ${(props) => props.lineHeight || ''};
`
export const Text3 = styled.div`
  font-size: ${(props) => props.size || `14px`};
  font-weight: ${(props) => props.weight || 500};
  color: ${(props) => props.color || 'var(--color-on-base-content-high)'};
`

export const H1 = styled.div`
  font-size: ${(props) => props.size || `18px`};
  font-weight: ${(props) => props.weight || 500};
  color: ${(props) => props.color || 'var(--color-on-base-content-high)'};
`

export const Title = styled.div`
  font-size: ${(props) => props.size || '40px'};
  font-weight: ${(props) => props.weight || 500};
  line-height: 27px;
  color: ${(props) => props.color || 'var(--color-on-base-content-high)'};
`

export const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 26.4px;
  color: var(--color-on-base-content-low);
`
